import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../../lib/utils/css';
import RowItemText from '../RowItemText';

import './RowItemDescription.scss';

class RowItemDescription extends React.Component {
  static propTypes = {
    useLightTheme: PropTypes.bool,
    useDarkTheme: PropTypes.bool,
    isRowHovered: PropTypes.bool,

    description: PropTypes.string,
    descriptionUrl: PropTypes.string,
    descriptionOnclick: PropTypes.func,
    qaParagraphText: PropTypes.string,
  };

  render() {
    const classNames = createBEM('RowItemDescription', {
      light: this.props.useLightTheme,
      dark: this.props.useDarkTheme,
      hovered: this.props.isRowHovered,
    });

    return (
      <RowItemText
        className={classNames}
        text={this.props.description}
        href={this.props.descriptionUrl}
        onClick={this.props.descriptionOnclick}
        qaTag={this.props.qaParagraphText}
      />
    );
  }
}

export default RowItemDescription;
